import React, { useContext } from "react";
import { ThemeContext } from "../context/themeContext";
import { Link } from "react-router-dom";
import IntegrationNotifications from "./IntegrationNotifications";

const Header = ({ onOpenSidebar }) => {
  const { toggleTheme, theme } = useContext(ThemeContext);
  return (
    <div className="sticky top-0 z-20">
      <div className="topbar text-textHeader bg-bgColor border-b-[1px] border-borderBottom">
        <div className="flex items-center gap-2">
          <button
            aria-label="Sidebar öffnen"
            className="dark:bg-dark-mode-header bg-light-mode-header rounded-md p-[5px] flex items-center justify-center cursor-pointer"
            onClick={onOpenSidebar || (() => {})}
          >
            <i className="bx bx-menu text-[20px]"></i>
          </button>
          <div className="logo ">
            <Link to="/">
              <img
                src={
                  theme === "dark"
                    ? "/static/logo-dark.svg"
                    : "/static/logo-light.svg"
                }
                className="edgelogo"
                alt="logo1"
              />
            </Link>
          </div>
        </div>
        <div className="flex justify-between items-center gap-3">
          {/* Icon-only (Tooltips erstmal raus). */}
          <Link
            to="/guide"
            aria-label="Edge Academy"
            className="dark:bg-dark-mode-header bg-light-mode-header rounded-md h-10 w-10 flex items-center justify-center hover:opacity-80 transition"
          >
            <img
              src={
                theme === "dark"
                  ? "/static/DarkMode/academy-active1.svg"
                  : "/static/LightMode/academy-active2.svg"
              }
              alt="Edge Academy"
              width={16}
              height={16}
            />
          </Link>
          <IntegrationNotifications />
          <button
            type="button"
            className="dark:bg-dark-mode-header bg-light-mode-header rounded-md h-10 w-10 flex items-center justify-center cursor-pointer hover:opacity-80 transition"
            onClick={toggleTheme}
          >
            <img
              src={
                theme === "dark"
                  ? "/static/Light-Mode.svg"
                  : "/static/dark-mode.svg"
              }
              width={21}
              height={21}
              alt="modeIcon"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
